<script setup></script>

<template>
  <div class="base-gradient py-8 md:py-24 px-6 text-md text-primary">
    <div class="mx-auto max-w-7xl">
      <div class="mx-auto max-w-2xl px-4 lg:max-w-none">
        <div class="max-w-full text-balance">
          <h2 class="text-3xl font-bold tracking-tight">
            {{ $t('landingPage.howSection.title') }}
          </h2>
          <p class="mt-16 text-sm">
            {{ $t('landingPage.howSection.text') }}
          </p>
        </div>
        <div class="mt-4 grid xl:grid-cols-2 grid-cols-1 gap-x-24 gap-y-10">
          <div>
            <!-- Image section -->
            <div class="mt-16 sm:mt-16 xl:mx-auto">
              <img
                src="../../assets/training-platform-screenshot.png"
                alt="Training platform"
                class="aspect-[5/2]] w-full object-cover"
              >
            </div>
            <h3 class="text-2xl mt-4 font-bold tracking-tight">
              {{ $t('landingPage.howSection.block1.title') }}
            </h3>
            <p class="mt-4 text-secondary">
              {{ $t('landingPage.howSection.block1.subtitle') }}
            </p>
            <ul class="mt-4 list-disc list-inside text-primary">
              <li>{{ $t('landingPage.howSection.block1.bullet1') }}</li>
              <li>{{ $t('landingPage.howSection.block1.bullet2') }}</li>
              <li>{{ $t('landingPage.howSection.block1.bullet3') }}</li>
              <li>{{ $t('landingPage.howSection.block1.bullet4') }}</li>
            </ul>
          </div>

          <div>
            <!-- Image section -->
            <div class="mt-16 sm:mt-16 xl:max-w-7xl">
              <img
                src="../../assets/management-platform-screenshot.png"
                alt="Management platform"
                class="aspect-[5/2]] w-full object-cover"
              >
            </div>
            <h3 class="text-2xl mt-4 font-bold tracking-tight">
              {{ $t('landingPage.howSection.block2.title') }}
            </h3>
            <p class="mt-4 text-secondary">
              {{ $t('landingPage.howSection.block2.subtitle') }}
            </p>
            <ul class="mt-4 list-disc list-inside text-primary">
              <li>{{ $t('landingPage.howSection.block2.bullet1') }}</li>
              <li>{{ $t('landingPage.howSection.block2.bullet2') }}</li>
              <li>{{ $t('landingPage.howSection.block2.bullet3') }}</li>
              <li>{{ $t('landingPage.howSection.block2.bullet4') }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
